import { render, staticRenderFns } from "./SkillSimSkillTooltip.vue?vue&type=template&id=18fa4685&scoped=true&"
import script from "./SkillSimSkillTooltip.vue?vue&type=script&lang=ts&"
export * from "./SkillSimSkillTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./SkillSimSkillTooltip.vue?vue&type=style&index=0&id=18fa4685&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa4685",
  null
  
)

export default component.exports